import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

const PortalScopeContext = createContext(null);

export function PortalScopeProvider({ children }) {
  const [portalScope, setPortalScopeState] = useState(() => {
    return localStorage.getItem("portalScope") || "Global";
  });

  const [userScope, setUserScopeState] = useState(() => {
    const stored = localStorage.getItem("scope");
    if (stored) return stored;
    try {
      const token = localStorage.getItem("token");
      if (token) {
        const decoded = jwtDecode(token);
        return decoded.scope || "Global";
      }
    } catch (e) {
      // ignore
    }
    return "Global";
  });

  const refreshScope = useCallback(() => {
    let newScope = "Global";
    const stored = localStorage.getItem("scope");
    if (stored) {
      newScope = stored;
    } else {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const decoded = jwtDecode(token);
          newScope = decoded.scope || "Global";
        }
      } catch (e) {
        // ignore
      }
    }
    setUserScopeState(newScope);
  }, []);

  const setPortalScope = useCallback((scope) => {
    if (scope !== "Global" && scope !== "Local") return;
    localStorage.setItem("portalScope", scope);
    setPortalScopeState(scope);
  }, []);

  useEffect(() => {
    if (userScope !== "Both") {
      const single = userScope === "Local" ? "Local" : "Global";
      if (portalScope !== single) {
        setPortalScopeState(single);
        localStorage.setItem("portalScope", single);
      }
    }
  }, [userScope, portalScope]);

  const scopeParam = userScope === "Both" ? `?scope=${portalScope}` : "";

  const value = {
    userScope,
    portalScope: userScope === "Both" ? portalScope : userScope,
    setPortalScope,
    refreshScope,
    scopeParam,
    canSwitchPortal: userScope === "Both",
  };

  return (
    <PortalScopeContext.Provider value={value}>
      {children}
    </PortalScopeContext.Provider>
  );
}

export function usePortalScope() {
  const ctx = useContext(PortalScopeContext);
  if (!ctx) {
    return {
      userScope: "Global",
      portalScope: "Global",
      setPortalScope: () => { },
      refreshScope: () => { },
      scopeParam: "",
      canSwitchPortal: false,
    };
  }
  return ctx;
}
